module.exports = __webpack_public_path__ + "static/media/surper-2.f9ff73f0.jpg";